export default "__VITE_ASSET__DYfkidoJ__"